export default {
  floor: "floor",
  first_floor: "First",
  //!
  semi_floor: "mezzanine",
  mezzanine_floor: "mezzanine",
  second_floor: "Second",
  third_floor: "Third",
  fourth_floor: "Fourth",
  fifth_floor: "Fifth",

  ground_floor: "Ground",
  //!
  room: "Room",
  rooms: "Rooms",
  primary_building: "Primary Building",
  office_letter_a: "A",
  office_letter_b: "B",
  office_letter_c: "C",
  office_letter_d: "D",
  building_C: "C",
  building_D: "D",
  building_H: "H",
  building_G: "G",
  building_K: "K",
  building_F: "F",
  auditorium: "Auditorium",
  auditoriums: "Auditoriums",
  student_groups: "Student Groups",
  professor_offices: "Professor Offices",
  technical_support: "Technical Support",
  ergastirio_kid: "Ergastirio KID",
  office_kid: "Office for Computers and Networks",
  ergasthrio_texnologikhs_ekpaideusis: "Lab of Technological Education",
  conference_room: "Conference Room",
  remote_education_room: "Remote Education Room",
  secretaries: "Secretaries",
  other: "Other",
  finance_secretary: "Finance and Accounting Secretary",
  european_studies_secretary: "International and European Studies Secretary",
  music_and_art_studies_secretary: "Music and Art Studies Secretary",
  balkan_studies_secretary: "Balkan, Slavic and Eastern Studies Secretary",
  ekp_secretary: "Educational and Social Policy Secretary",
  econ_secretary: "Secretary of Economics Studies",
  internship_office_2: "Internship Office",
  //liaison_office:"Liaison Office"
  student_care_office: "Student Care Office",
  dai_secretary: "Applied Informatics Secretary",
  ba_secretary: "Organization and Management of Enterprises Secretary",
  library: "library",
  gym: "Gym",
  aiesec: "AIESEC",
  open_source_uom: "Open Source UoM",
  student_restaurant: "Student Restaurant",
  cafeteria: "Cafeteria",
  concierge: "Concierge Desk",
  ceremony_hall_for_navigation: "01 (Ceremony Hall)",
  post_office: "Post Office",
  diatmimatika_metaptixiaka_secretary:
    "Interdepartmental Postgraduate Programmes",
  photocopy_space: "Photocopier",
  lab: "Lab",
  depname_bso: "Balkan, Slavic & Oriental Studies",
  depname_ies: "International and European Studies",
  depname_esp: "Educational & Social Policy",
  depname_dai: "Applied Informatics",
  depname_fin: "Accounting and Finance",
  depname_msa: "Music Science & Art",
  depname_eco: "Economics",
  depname_ba: "Business Administration",
  select_where_to_go: "What are you looking for?",
  //dont like this
  select_location: "Select location",
  virtual_tour: "Virtual Tour",
  cant_find_building_prompt: "Don't know where the building is?",
  cant_see_room_prompt:
    "In case you can't see the room you can zoom in on the image",
  closest_elevator_prompt: "The closest elevator relative to that room is:",
  enter_elevator_prompt: "Get in the elevator and go to the",
  see_room_again: "See again where the room is",
};
